export default "__VITE_ASSET__lg35SBNf__"